import { useEffect } from "react";
import { UserLayout } from "../UserLayout";
import {
  CheckInActivityDetailSection,
  CheckInActivityHeaderSection,
  useLocation,
  useNavigate,
} from "../../../modules";

export const CheckInActivity = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    navigate(pathname, {
      tab: "1",
    });
  }, [navigate, pathname]);
  return (
    <UserLayout fillViewport banner={<CheckInActivityHeaderSection />}>
      <CheckInActivityDetailSection />
    </UserLayout>
  );
};
